function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mail-new-hi-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M160 152H32a16 16 0 01-16-16V48a8 8 0 018-8h144a8 8 0 018 8v88a16 16 0 01-16 16z",
  fill: "none"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "mail-new-hi-dark_svg__b",
  "data-name": "Mail_new_ic_hi",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  d: "M160 152H32a16 16 0 01-16-16V48a8 8 0 018-8h144a8 8 0 018 8v88a16 16 0 01-16 16z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mail-new-hi-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 56l96 96h48a16 16 0 0016-16V56z",
  opacity: 0.2,
  fill: "#bcbcbc"
})), /*#__PURE__*/React.createElement("path", {
  d: "M168 40H24a8 8 0 00-8 8v8l68 42s5.83 4 12 4 12-4 12-4l68-42v-8a8 8 0 00-8-8z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 100c-6.17 0-12-4-12-4L16 54v2l68 42s5.83 4 12 4 12-4 12-4l68-42v-2l-68 42s-5.83 4-12 4zM160 150H32a16 16 0 01-16-16v2a16 16 0 0016 16h128a16 16 0 0016-16v-2a16 16 0 01-16 16z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 72a12 12 0 1012 12 12 12 0 00-12-12zm5.87 15.22a6.29 6.29 0 01-1.72 2.08 6.45 6.45 0 01-5.79 1.13 6.85 6.85 0 01-3.83-2.87 7.32 7.32 0 01-.87-1.93v-.16a8 8 0 01-.22-1.19 8.41 8.41 0 010-1.24v-.13a9.46 9.46 0 01.26-1.73 10.41 10.41 0 013.3-5.36 11.24 11.24 0 013.29-1.93c.33-.13.66-.24 1-.33l.61-.17a12.16 12.16 0 011.52-.27 6.11 6.11 0 011.51 0l.24.06A5 5 0 0097.25 78v.16a7.9 7.9 0 012.54 1 5.72 5.72 0 011.66 1.53l.1.14a5.68 5.68 0 01.72 1.54 6.88 6.88 0 01.28 1.74v.23a6.43 6.43 0 01-.68 2.88z",
  fill: "#e60000"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Mail_new_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Mail_new_ic_hi",
  width: 192,
  height: 192,
  xlinkHref: "#mail-new-hi-dark_svg__b"
}));

var SvgMailNewHiDark = function SvgMailNewHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgMailNewHiDark;